import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ContractingStatusColorEnum, OnlineContractingStateEnum } from 'v3/data/store/onlineContracting/enums';
import { onlineContractingInitialState } from 'v3/data/store/onlineContracting/state';
import { FiltersType, OnlineContractingListType } from 'v3/data/store/onlineContracting/types';
import { IGetPaymentDetailsResponse } from 'v3/services/online/interfaces/response';

export const onlineContractingSlice = createSlice({
  name: 'onlineContracting',
  initialState: onlineContractingInitialState,
  reducers: {
    setOnlineContractingList: (state, action: PayloadAction<OnlineContractingListType>) => {
      state.list = action.payload;
      return state;
    },
    setFilterCurrentPage: (state, action: PayloadAction<number>) => {
      state.filter.page = action.payload;
      return state;
    },
    setFilterRowsPerPage: (state, action: PayloadAction<number>) => {
      state.filter.rowsPerPage = action.payload;
      return state;
    },
    setStatusColor: (state, action: PayloadAction<OnlineContractingStateEnum>) => {
      state.statusColor = ContractingStatusColorEnum[action.payload] || ContractingStatusColorEnum.undefined;
    },
    setPaymentDetails: (state, action: PayloadAction<IGetPaymentDetailsResponse>) => {
      state.paymentDetails = action.payload;
      return state;
    },
    clearOnlineContractingInfo: (state) => {
      state.paymentDetails = onlineContractingInitialState.paymentDetails;
      return state;
    },

    setFilters: (state, action: PayloadAction<FiltersType>) => {
      state.filter = action.payload;
      return state;
    },
    setContractingState: (state, action: PayloadAction<OnlineContractingStateEnum>) => {
      state.contractingState = action.payload;
      return state;
    },
    setContractingKey: (state, action: PayloadAction<string>) => {
      state.contractingKey = action.payload;
      return state;
    },
  },
});
